<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <div>
    something here
    <option-manager :storeId="storeId" :menuDraftVariation="menuDraftVariation" :questionId="questionId" />
  </div>
</template>

<script>
import OptionManager from '../OptionsManager'

export default {
  dependencies: ['questionType'],
  props: {
    storeId: String,
    menuDraftVariation: String,
    questionId: String
  },
  components: {
    OptionManager
  }
}
</script>
